import type { ReactNode } from 'react';
import { UserDirectoryContext, useUserDirectoryData } from './userDirectory';

/** Mounted once, inside the database provider — see {@link UserDirectory}. */
export function UserDirectoryProvider({ children }: { children: ReactNode }) {
    const directory = useUserDirectoryData();
    return (
        <UserDirectoryContext.Provider value={directory}>
            {children}
        </UserDirectoryContext.Provider>
    );
}
